import { Injectable, signal, WritableSignal } from '@angular/core';
import { AppTypeEnum } from '../enums';
import { StorageConstants } from '../constants';
import { ApiService } from '../services/api.service';
import { StorageHelper } from './storage.helper';

@Injectable({
    providedIn: 'root'
})
export class NavigatorHelper {
    public static appType: WritableSignal<AppTypeEnum | null> = signal(null);

    public static setAppType(appType: AppTypeEnum){
    NavigatorHelper.appType.set(appType);
    StorageHelper.setItem(StorageConstants.APP_TYPE, appType);

    }
}